import styled, { css } from 'styled-components'
import { TextCircleIcon } from '@sainsburys-tech/bolt-icons'
import NectarIcon from './NectarIcon'

const roundelMargin = css`
  ${(props) =>
    css`
      margin-left: ${props.theme.size.spacing.md};
      margin-top: ${props.theme.size.spacing.md};
    `}
`

const StyledRoundel = styled(TextCircleIcon)`
  position: absolute;
  z-index: 1;
  ${(props) =>
    props.component === 'm053' &&
    css`
      top: 5%;
      right: 50%;
      left: 5%;
    `}

  ${(props) =>
    props.component === 'c001' &&
    css`
      ${roundelMargin}
      top: 3%;
      left: 2%;
      width: 30%;
      min-width: 90px;
      @media screen and (max-width: ${props.theme.size.breakpoint['max-width'].sm}) {
        width: 35%;
      }
    `}
    ${(props) =>
    props.component === 'c004' &&
    css`
      top: 0;
      left: 0;
      ${roundelMargin}
      width: 35%;
      min-width: 50px;
      @media screen and (max-width: ${props.theme.size.breakpoint['max-width'].sm}) {
        width: 30%;
      }
    `}

  text {
    font-family: ${(props) => props.theme.font.family['display-1']};
    letter-spacing: 0.02rem;
    font-weight: ${(props) => props.theme.font.weight['extra-bold']};
    font-size: ${(props) => props.theme.font.size['display-1']};
    stroke: none;
  }
`

const StyledNectarRoundel = styled(NectarIcon)`
  position: absolute;
  z-index: 1;
  top: 3%;
  right: 50%;
  left: 2%;
  width: 30%;

  ${(props) =>
    props.component === 'c001' &&
    css`
      width: 20%;
      min-width: 65px;
      @media screen and (max-width: ${props.theme.size.breakpoint['max-width'].sm}) {
        width: 25%;
      }
    `}

  ${(props) =>
    props.component === 'c004' &&
    css`
      width: 25%;
    `}
`

export { StyledRoundel, StyledNectarRoundel }
